import React from "react";
import Modal from "./Modal";
import { F, CLSNAME, CABIN } from "../data/aircraft";
import { STATS } from "../data/stats";
import { fmtH, seatsTxt } from "../lib/engine";
import { Picture, Price } from "../lib/icons";

export default function AircraftModal({ code, g, dist, from, to, onClose, onRequest }) {
  const f = F[code];
  const st = STATS[code] || { n: 0 };
  const feats = [
    f.tw ? "Twin engine" : f.eng && f.eng.startsWith("3") ? "Three engines" : f.k === "balloon" ? "" : "Single engine",
    f.pr ? "Pressurised cabin" : (f.k === "heli" || f.k === "balloon" ? "" : "Unpressurised"),
    f.hi ? "Strong at high altitude" : "",
    f.use === "train" ? "Mostly used for training and joyrides" : "",
    f.use === "survey" ? "Mostly used for aerial work and survey" : "",
  ].filter(Boolean);
  const trip = g && from && to ? (
    <div className="why"><b>Your trip:</b> {from} to {to} in about <b>{fmtH(g.block)}</b>{g.stops ? ` including ${g.stops} fuel stop${g.stops > 1 ? "s" : ""}` : ", nonstop"}. Based on {f.s} kt cruise over about {Math.round(dist).toLocaleString("en-IN")} nm.</div>
  ) : null;
  return (
    <Modal title={f.n} onClose={onClose}>
      <div className="hero2">
        <div className="pic"><Picture code={code} />{g && g.badge ? <span className="badge">{g.badge}</span> : null}</div>
        <div>
          <h2>{f.n}</h2>
          <p className="subt">{CLSNAME[f.c]} · {st.n} in India's charter fleet</p>
          <div className="specs">
            <div><span>Engines</span><b>{f.eng}</b></div>
            <div><span>{f.use === "cargo" ? "Payload" : "Seats in India"}</span><b>{seatsTxt(code)}</b></div>
            <div><span>Range</span><b>{f.r.toLocaleString("en-IN")} nm · {Math.round(f.r * 1.852).toLocaleString("en-IN")} km</b></div>
            <div><span>Cruise speed</span><b>{f.s} kt · {Math.round(f.s * 1.852)} km/h</b></div>
            <div><span>Max altitude</span><b>{f.ceil.toLocaleString("en-IN")} ft</b></div>
            <div><span>Cabin</span><b>{CABIN[f.c]}</b></div>
            <div><span>Manufacturer</span><b>{f.mk}</b></div>
            <div><span>Relative cost</span><b style={{ letterSpacing: ".06em" }}><Price tier={f.t} /></b></div>
          </div>
        </div>
      </div>
      <p style={{ margin: 0, fontSize: 16 }}>{f.d}</p>
      {feats.length ? <div className="feat">{feats.map((x) => <span key={x}>{x}</span>)}</div> : null}
      {trip}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <button className="btn primary" type="button" onClick={() => onRequest(code)}>Request this aircraft</button>
      </div>
      <p className="subt" style={{ margin: 0, fontSize: 13 }}>Range is the typical maximum with reserves; full cabins, hot weather and high airfields reduce it. Seats show the approved layouts of this type in India.</p>
    </Modal>
  );
}
